// assets/rm-reviews.js
(() => {
  const INIT_KEY = 'rmReviewsInited';

  function cards(track){ return Array.from(track.querySelectorAll('.rm-card')); }
  function indexOfCurrent(track){
    const list = cards(track);
    if (!list.length) return 0;
    const base = list[0].offsetLeft;
    let idx = 0, min = Infinity;
    list.forEach((el,i) => {
      const diff = Math.abs((el.offsetLeft - base) - track.scrollLeft);
      if (diff < min){ min = diff; idx = i; }
    });
    return idx;
  }
  function goTo(track, i){
    const list = cards(track);
    const target = list[i]; if (!target) return;
    const base = list[0].offsetLeft;
    track.scrollTo({ left: target.offsetLeft - base, behavior: 'smooth' });
  }
  function buildDots(root, track){
    const dots = root.querySelector('.rm-reviews__dots');
    if (!dots) return;
    dots.innerHTML = '';
    cards(track).forEach((_,i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Ir para slide ${i+1}`);
      b.addEventListener('click', () => goTo(track, i));
      dots.appendChild(b);
    });
    updateDots(root, track);
  }
  function updateDots(root, track){
    const dots = root.querySelector('.rm-reviews__dots');
    if (!dots) return;
    const idx = indexOfCurrent(track);
    dots.querySelectorAll('button').forEach((b,i)=> b.setAttribute('aria-current', i===idx ? 'true' : 'false'));
  }

  function initOne(root){
    if (!root || root[INIT_KEY]) return;
    const track = root.querySelector('.rm-reviews__track');
    if (!track) return;

    const prev = root.querySelector('.rm-btn.prev');
    const next = root.querySelector('.rm-btn.next');
    const right = root.querySelector('.rm-reviews__right');
    const autoplay = right?.dataset.autoplay === 'true';
    const interval = parseInt(right?.dataset.interval || '6000', 10);
    let timer = null;

    prev?.addEventListener('click', () => goTo(track, Math.max(0, indexOfCurrent(track)-1)));
    next?.addEventListener('click', () => goTo(track, Math.min(cards(track).length-1, indexOfCurrent(track)+1)));

    buildDots(root, track);
    track.addEventListener('scroll', () => {
      clearTimeout(track._t);
      track._t = setTimeout(() => updateDots(root, track), 80);
    });

    function start(){
      if (!autoplay) return;
      stop();
      timer = setInterval(() => {
        const n = (indexOfCurrent(track)+1) % cards(track).length;
        goTo(track, n);
      }, interval);
    }
    function stop(){ if (timer){ clearInterval(timer); timer = null; } }

    track.addEventListener('pointerenter', stop);
    track.addEventListener('pointerleave', start);
    window.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

    start();
    // marca como inicializado (evita bind duplicado quando editor recarrega a seção)
    root[INIT_KEY] = { destroy: stop };
  }

  function destroyOne(root){
    const s = root?.[INIT_KEY];
    if (s?.destroy) s.destroy();
    if (root) root[INIT_KEY] = null;
  }

  // 1) página normal
  const initAll = () => document.querySelectorAll('.rm-reviews').forEach(initOne);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // 2) editor do tema (re-render sem reload)
  document.addEventListener('shopify:section:load', e => {
    e.target?.querySelectorAll?.('.rm-reviews').forEach(initOne);
  });
  document.addEventListener('shopify:section:unload', e => {
    e.target?.querySelectorAll?.('.rm-reviews').forEach(destroyOne);
  });
})();
